import React, { FC } from 'react';
import { SystemCurrency } from '@okletsplay/core';
import { MutedText, FormatCurrency, FormatCurrencyType } from 'shared/components/Format/Currency';

interface ComponentProps {
  amounts: Record<string, number>;
}

export const MinWithdrawAmountTip: FC<ComponentProps> = ({ amounts }) => {
  const amountEntries = Object.entries(amounts);

  return (
    <MutedText>
      Minimum to withdraw{': '}
      {amountEntries.map(([minAmountCurrency, minAmount], index) => (
        <React.Fragment key={minAmountCurrency + minAmount}>
          <FormatCurrency
            currency={minAmountCurrency as SystemCurrency}
            amount={minAmount}
            type={FormatCurrencyType.Crypto}
          />
          {index === amountEntries.length - 1 ? '.' : ', '}
        </React.Fragment>
      ))}
    </MutedText>
  );
};
